import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import './styles.css';
import HelpIcon from '@mui/icons-material/Help';
import ReactTooltip from 'react-tooltip';

export default function BoxQuantOpenOccurrences({ occurrences }) {
  const primeiro = {
    height: '140px',
    paddingTop: 5,
    backgroundColor: "#fff"
  };

  const [openOccurrences, setOpenOccurrences] = useState([]);

  useEffect(() => {
    let filtred = occurrences.filter(ocorrencia => {
      return (ocorrencia.status === "Novo" || ocorrencia.status === "Em análise")
    })
    setOpenOccurrences(state => filtred)
  }, [occurrences])

  return (
    <>
      <Card
        sx={{ height: '100%' }}
      >
        <CardContent style={primeiro}>
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: 'space-between' }}

          >
            <Grid item>
              <Typography
                className="box-title"
                gutterBottom
                variant="h6"
              >
                Ocorrências Abertas
                <HelpIcon style={{ 'color': '#a1a5ab', marginTop: -7 }} fontSize="small" data-for="proportion-info" data-place="bottom" data-tip='Ocorrências Abertas são as<br>ocorrências "Novas" e "Em análise".' />
                <ReactTooltip id="proportion-info" className='popup' />
              </Typography>
              <Typography
                color="textPrimary"
                variant="h3"
              >
                {openOccurrences.length}
              </Typography>
              <br />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>);
}